import React from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { cn } from 'components/lib/utils';

import {
  MAIN_SIDEBAR_WIDTH,
  TemplateStudioMainSidebar
} from './Main/MainSidebar';
import { TemplateStudioSecondarySidebar } from './Secondary/Secondary';

export const SECONDARY_SIDEBAR_WIDTH = 223;

export const TemplateStudioSidebar: React.FC = () => {
  const { openSidebarBlock, BlockSecondarySidebar, isSecondarySidebarOpen } =
    useTemplateStudioState();

  return (
    <div
      className={cn(
        'flex shrink-0 w-content overflow-y-hidden',
        isSecondarySidebarOpen &&
          `w-[${MAIN_SIDEBAR_WIDTH + SECONDARY_SIDEBAR_WIDTH}px]`
      )}
    >
      <TemplateStudioMainSidebar />

      <AnimatePresence initial={false} mode="wait">
        {!!BlockSecondarySidebar && (
          <motion.div
            key={String(openSidebarBlock)}
            initial={{ width: 0 }}
            animate={{
              width: SECONDARY_SIDEBAR_WIDTH,
              minWidth: SECONDARY_SIDEBAR_WIDTH
            }}
            exit={{ width: 0 }}
            transition={{
              duration: 0.18,
              ease: [0.22, 1, 0.36, 1],
              delay: 0
            }}
            className={`min-w-[${SECONDARY_SIDEBAR_WIDTH}px]`}
          >
            <motion.div
              initial={{ x: '-100%', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: '-100%', opacity: 0 }}
              transition={{ duration: 0, ease: [0.4, 0, 0.2, 1] }}
              className={`h-full min-w-[${SECONDARY_SIDEBAR_WIDTH}px]`}
            >
              <TemplateStudioSecondarySidebar
                SidebarBlockComponent={BlockSecondarySidebar}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
